// Verbatim from Hedge-Fund-Tracking-System apps/web/src/components/ui/stat-badge.tsx.
// Dropped the fund-specific *StatusBadge helpers (they reference @hedge/shared
// types we don't have); the base StatBadge is identical.
import { cn } from '../../lib/utils';

type BadgeVariant = 'positive' | 'negative' | 'warning' | 'neutral' | 'info' | 'pending';

interface StatBadgeProps {
  label: string;
  variant?: BadgeVariant;
  dot?: boolean;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  positive: 'bg-positive-muted text-positive border-positive/20',
  negative: 'bg-negative-muted text-negative border-negative/20',
  warning: 'bg-warning-muted text-warning border-warning/20',
  pending: 'bg-warning-muted text-warning border-warning/20',
  neutral: 'bg-muted text-muted-foreground border-border',
  info: 'bg-primary/10 text-primary border-primary/20',
};

const dotStyles: Record<BadgeVariant, string> = {
  positive: 'bg-positive',
  negative: 'bg-negative',
  warning: 'bg-warning',
  pending: 'bg-warning',
  neutral: 'bg-muted-foreground',
  info: 'bg-primary',
};

export function StatBadge({ label, variant = 'neutral', dot = false, className }: StatBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border',
        variantStyles[variant],
        className,
      )}
    >
      {dot && <span className={cn('h-1.5 w-1.5 rounded-full flex-shrink-0', dotStyles[variant])} />}
      {label}
    </span>
  );
}
